import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ_ITEMS } from "../../lib/constants";

export default function FAQ() {
  useEffect(() => {
    // Inject FAQPage JSON-LD
    const id = "faqpage-jsonld";
    if (document.getElementById(id)) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="bg-white text-[#1F2937] section-pad">
      <div className="container-tight grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-20">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="divider-accent" />
            <span className="kicker">Dudas frecuentes</span>
          </div>
          <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
            Preguntas <span className="text-accent">frecuentes</span>.
          </h2>
          <p className="mt-6 max-w-md text-[#1F2937]/70 text-base md:text-lg">
            Resolvemos las dudas más comunes sobre tiempos, garantías, materiales y proceso.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQ_ITEMS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#DDE2D5]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 text-left font-display font-bold text-lg md:text-xl text-[#1F2937] hover:text-accent hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#1F2937]/70 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
